import productDetail from "../pages/product-detail";

const initProductBox = () => {
  const product = document.querySelectorAll(".product");

  product.forEach(function (product) {
    const name = product.querySelector(".name");
    const desc = product.querySelector(".p-desc");
    const availability = product.querySelector(".availability");
    const price = product.querySelector(".price-final");
    const priceFinal = product.querySelector(".price-final strong");
    const priceStandart = product.querySelector(".price-standard");
    const rating = product.querySelector(".ratings-wrapper");

    rating && rating.remove();
    $(availability).insertBefore(price);
    $(priceStandart).insertBefore(priceFinal);
    $(desc).insertAfter(name);
  });
};

export { initProductBox };
